module.exports = __webpack_public_path__ + "img/red-riding-hood.a69983e3.png";